export interface UploadMasterdata {
  [key: string]: any;
  "Coordenação": string;
  "Carteira": string;
  "Família": string;
  "Família Rotulada": string;
  "Descrição Material": string;
  "Número Material": string;
  "Centro": string;
  "Unidade medida": string;
  "Descrição unidade medida": string;
  "Horizonte programação": string;
  "Estoque mínimo": string;
  "Estoque máximo": string;
  "Ponto reabastecimento %": string;
  "Periodicidade": string;
  "Auto aceite composição carga": string;
  "Saneamento de volumes pendentes": string;
  "Replanejamento data entrega": string;
  "Replanejamento grade pedidos": string;
  "Ativo": string;
  "Produção": string;
  "Email do usuário responsável": string;
  "Sugestão externa": string;
  "Necessidade futura": string;
  "Apenas Transferencia": string;
  "Autopilot": string;
  "Deflator": string;
  "% Deflação": string;
  "Saneamento de pedidos": string;
  "Quantidade de dias para saneamento de pedidos": string;
  "Relevância OOR": string;
  "Sugestões a partir de D -": string;
  "Fornecedor nome 1": string;
  "Fornecedor arredondamento 1": string;
  "Fornecedor lote mínimo 1": string;
  "Fornecedor quebra entrega 1": string;
  "Fornecedor Incoterm 1": string;
  "Fornecedor SLA 1": string;
  "Fornecedor tempo transporte 1": string;
  "Fornecedor cria composição de carga automática 1": string;
  "Fornecedor nome 2": string;
  "Fornecedor arredondamento 2": string;
  "Fornecedor lote mínimo 2": string;
  "Fornecedor quebra entrega 2": string;
  "Fornecedor Incoterm 2": string;
  "Fornecedor SLA 2": string;
  "Fornecedor tempo transporte 2": string;
  "Fornecedor cria composição de carga automática 2": string;
  "Fornecedor nome 3": string;
  "Fornecedor arredondamento 3": string;
  "Fornecedor lote mínimo 3": string;
  "Fornecedor quebra entrega 3": string;
  "Fornecedor Incoterm 3": string;
  "Fornecedor SLA 3": string;
  "Fornecedor tempo transporte 3": string;
  "Fornecedor cria composição de carga automática 3": string;
  "Fornecedor nome 4": string;
  "Fornecedor arredondamento 4": string;
  "Fornecedor lote mínimo 4": string;
  "Fornecedor quebra entrega 4": string;
  "Fornecedor Incoterm 4": string;
  "Fornecedor SLA 4": string;
  "Fornecedor tempo transporte 4": string;
  "Fornecedor cria composição de carga automática 4": string;
  "Fornecedor nome 5": string;
  "Fornecedor arredondamento 5": string;
  "Fornecedor lote mínimo 5": string;
  "Fornecedor quebra entrega 5": string;
  "Fornecedor Incoterm 5": string;
  "Fornecedor SLA 5": string;
  "Fornecedor tempo transporte 5": string;
  "Fornecedor cria composição de carga automática 5": string;
  "Fornecedor nome 6": string;
  "Fornecedor arredondamento 6": string;
  "Fornecedor lote mínimo 6": string;
  "Fornecedor quebra entrega 6": string;
  "Fornecedor Incoterm 6": string;
  "Fornecedor SLA 6": string;
  "Fornecedor tempo transporte 6": string;
  "Fornecedor cria composição de carga automática 6": string;
  "Fornecedor nome 7": string;
  "Fornecedor arredondamento 7": string;
  "Fornecedor lote mínimo 7": string;
  "Fornecedor quebra entrega 7": string;
  "Fornecedor Incoterm 7": string;
  "Fornecedor SLA 7": string;
  "Fornecedor tempo transporte 7": string;
  "Fornecedor cria composição de carga automática 7": string;
  "Fornecedor nome 8": string;
  "Fornecedor arredondamento 8": string;
  "Fornecedor lote mínimo 8": string;
  "Fornecedor quebra entrega 8": string;
  "Fornecedor Incoterm 8": string;
  "Fornecedor SLA 8": string;
  "Fornecedor tempo transporte 8": string;
  "Fornecedor cria composição de carga automática 8": string;
  "Fornecedor nome 9": string;
  "Fornecedor arredondamento 9": string;
  "Fornecedor lote mínimo 9": string;
  "Fornecedor quebra entrega 9": string;
  "Fornecedor Incoterm 9": string;
  "Fornecedor SLA 9": string;
  "Fornecedor tempo transporte 9": string;
  "Fornecedor cria composição de carga automática 9": string;
  "Fornecedor nome 10": string;
  "Fornecedor arredondamento 10": string;
  "Fornecedor lote mínimo 10": string;
  "Fornecedor quebra entrega 10": string;
  "Fornecedor Incoterm 10": string;
  "Fornecedor SLA 10": string;
  "Fornecedor tempo transporte 10": string;
  "Fornecedor cria composição de carga automática 10": string;
}

export const UploadMasterdataPtBrCSVEmpty = {
  "Coordenação": "",
  "Carteira": "",
  "Família": "",
  "Família Rotulada": "",
  "Descrição Material": "",
  "Número Material": "",
  "Centro": "",
  "Unidade medida": "",
  "Descrição unidade medida": "",
  "Horizonte programação": "",
  "Estoque mínimo": "",
  "Estoque máximo": "",
  "Ponto reabastecimento %": "",
  "Periodicidade": "",
  "Auto aceite composição carga": "",
  "Saneamento de volumes pendentes": "",
  "Replanejamento data entrega": "",
  "Replanejamento grade pedidos": "",
  "Ativo": "",
  "Produção": "",
  "Email do usuário responsável": "",
  "Sugestão externa": "",
  "Necessidade futura": "",
  "Apenas Transferencia": "",
  "Autopilot": "",
  "Deflator": "",
  "% Deflação": "",
  "Saneamento de pedidos": "",
  "Quantidade de dias para saneamento de pedidos": "",
  "Relevância OOR": "",
  "Sugestões a partir de D -": "",
  "Fornecedor nome 1": "",
  "Fornecedor arredondamento 1": "",
  "Fornecedor lote mínimo 1": "",
  "Fornecedor quebra entrega 1": "",
  "Fornecedor Incoterm 1": "",
  "Fornecedor SLA 1": "",
  "Fornecedor tempo transporte 1": "",
  "Fornecedor cria composição de carga automática 1": "",
  "Fornecedor nome 2": "",
  "Fornecedor arredondamento 2": "",
  "Fornecedor lote mínimo 2": "",
  "Fornecedor quebra entrega 2": "",
  "Fornecedor Incoterm 2": "",
  "Fornecedor SLA 2": "",
  "Fornecedor tempo transporte 2": "",
  "Fornecedor cria composição de carga automática 2": "",
  "Fornecedor nome 3": "",
  "Fornecedor arredondamento 3": "",
  "Fornecedor lote mínimo 3": "",
  "Fornecedor quebra entrega 3": "",
  "Fornecedor Incoterm 3": "",
  "Fornecedor SLA 3": "",
  "Fornecedor tempo transporte 3": "",
  "Fornecedor cria composição de carga automática 3": "",
  "Fornecedor nome 4": "",
  "Fornecedor arredondamento 4": "",
  "Fornecedor lote mínimo 4": "",
  "Fornecedor quebra entrega 4": "",
  "Fornecedor Incoterm 4": "",
  "Fornecedor SLA 4": "",
  "Fornecedor tempo transporte 4": "",
  "Fornecedor cria composição de carga automática 4": "",
  "Fornecedor nome 5": "",
  "Fornecedor arredondamento 5": "",
  "Fornecedor lote mínimo 5": "",
  "Fornecedor quebra entrega 5": "",
  "Fornecedor Incoterm 5": "",
  "Fornecedor SLA 5": "",
  "Fornecedor tempo transporte 5": "",
  "Fornecedor cria composição de carga automática 5": "",
  "Fornecedor nome 6": "",
  "Fornecedor arredondamento 6": "",
  "Fornecedor lote mínimo 6": "",
  "Fornecedor quebra entrega 6": "",
  "Fornecedor Incoterm 6": "",
  "Fornecedor SLA 6": "",
  "Fornecedor tempo transporte 6": "",
  "Fornecedor cria composição de carga automática 6": "",
  "Fornecedor nome 7": "",
  "Fornecedor arredondamento 7": "",
  "Fornecedor lote mínimo 7": "",
  "Fornecedor quebra entrega 7": "",
  "Fornecedor Incoterm 7": "",
  "Fornecedor SLA 7": "",
  "Fornecedor tempo transporte 7": "",
  "Fornecedor cria composição de carga automática 7": "",
  "Fornecedor nome 8": "",
  "Fornecedor arredondamento 8": "",
  "Fornecedor lote mínimo 8": "",
  "Fornecedor quebra entrega 8": "",
  "Fornecedor Incoterm 8": "",
  "Fornecedor SLA 8": "",
  "Fornecedor tempo transporte 8": "",
  "Fornecedor cria composição de carga automática 8": "",
  "Fornecedor nome 9": "",
  "Fornecedor arredondamento 9": "",
  "Fornecedor lote mínimo 9": "",
  "Fornecedor quebra entrega 9": "",
  "Fornecedor Incoterm 9": "",
  "Fornecedor SLA 9": "",
  "Fornecedor tempo transporte 9": "",
  "Fornecedor cria composição de carga automática 9": "",
  "Fornecedor nome 10": "",
  "Fornecedor arredondamento 10": "",
  "Fornecedor lote mínimo 10": "",
  "Fornecedor quebra entrega 10": "",
  "Fornecedor Incoterm 10": "",
  "Fornecedor SLA 10": "",
  "Fornecedor tempo transporte 10": "",
  "Fornecedor cria composição de carga automática 10": "",
}

export const UploadMasterdataEsCSVEmpty = {
  "Coordinación": "",
  "Grupo de materiales": "",
  "Familia": "",
  "Familia Rotulada": "",
  "Descripción Material": "",
  "Número Material": "",
  "Centro": "",
  "Unidad medida": "",
  "Descripción de unidad de medida": "",
  "Horizonte de programación": "",
  "Stock mínimo": "",
  "Stock máximo": "",
  "Punto de reabastecimiento %": "",
  "Frecuencia": "",
  "Autoaceptar composición de carga": "",
  "Saneamiento de volúmenes pendientes": "",
  "Reprogramación de Fecha de Entrega": "",
  "Replanificación de Capacidad de Pedidos": "",
  "Activo": "",
  "Producción": "",
  "Email del usuario responsable": "",
  "Sugerencia externa": "",
  "Necesidad Futura": "",
  "Solo pedido de transferencia": "",
  "Autopilot": "",
  "Deflator": "",
  "% de Deflación": "",
  "Órden de saneamiento": "",
  "Número de días para procesar pedidos": "",
  "Relevancia OOR": "",
  "Sugerencias a partir de D -": "",
  "Código del Proveedor 1": "",
  "Proveedor de redondeo 1": "",
  "Proveedor de lote mínimo 1": "",
  "Capacidad Máxima del camión 1": "",
  "Proveedor Incoterm 1": "",
  "Proveedor SLA 1": "",
  "Tiempo de tránsito del proveedor 1": "",
  "El proveedor crea una composición de carga automática 1": "",
  "Código del Proveedor 2": "",
  "Proveedor de redondeo 2": "",
  "Proveedor de lote mínimo 2": "",
  "Capacidad Máxima del camión 2": "",
  "Proveedor Incoterm 2": "",
  "Proveedor SLA 2": "",
  "Tiempo de tránsito del proveedor 2": "",
  "El proveedor crea una composición de carga automática 2": "",
  "Código del Proveedor 3": "",
  "Proveedor de redondeo 3": "",
  "Proveedor de lote mínimo 3": "",
  "Capacidad Máxima del camión 3": "",
  "Proveedor Incoterm 3": "",
  "Proveedor SLA 3": "",
  "Tiempo de tránsito del proveedor 3": "",
  "El proveedor crea una composición de carga automática 3": "",
  "Código del Proveedor 4": "",
  "Proveedor de redondeo 4": "",
  "Proveedor de lote mínimo 4": "",
  "Capacidad Máxima del camión 4": "",
  "Proveedor Incoterm 4": "",
  "Proveedor SLA 4": "",
  "Tiempo de tránsito del proveedor 4": "",
  "El proveedor crea una composición de carga automática 4": "",
  "Código del Proveedor 5": "",
  "Proveedor de redondeo 5": "",
  "Proveedor de lote mínimo 5": "",
  "Capacidad Máxima del camión 5": "",
  "Proveedor Incoterm 5": "",
  "Proveedor SLA 5": "",
  "Tiempo de tránsito del proveedor 5": "",
  "El proveedor crea una composición de carga automática 5": "",
  "Código del Proveedor 6": "",
  "Proveedor de redondeo 6": "",
  "Proveedor de lote mínimo 6": "",
  "Capacidad Máxima del camión 6": "",
  "Proveedor Incoterm 6": "",
  "Proveedor SLA 6": "",
  "Tiempo de tránsito del proveedor 6": "",
  "El proveedor crea una composición de carga automática 6": "",
  "Código del Proveedor 7": "",
  "Proveedor de redondeo 7": "",
  "Proveedor de lote mínimo 7": "",
  "Capacidad Máxima del camión 7": "",
  "Proveedor Incoterm 7": "",
  "Proveedor SLA 7": "",
  "Tiempo de tránsito del proveedor 7": "",
  "El proveedor crea una composición de carga automática 7": "",
  "Código del Proveedor 8": "",
  "Proveedor de redondeo 8": "",
  "Proveedor de lote mínimo 8": "",
  "Capacidad Máxima del camión 8": "",
  "Proveedor Incoterm 8": "",
  "Proveedor SLA 8": "",
  "Tiempo de tránsito del proveedor 8": "",
  "El proveedor crea una composición de carga automática 8": "",
  "Código del Proveedor 9": "",
  "Proveedor de redondeo 9": "",
  "Proveedor de lote mínimo 9": "",
  "Capacidad Máxima del camión 9": "",
  "Proveedor Incoterm 9": "",
  "Proveedor SLA 9": "",
  "Tiempo de tránsito del proveedor 9": "",
  "El proveedor crea una composición de carga automática 9": "",
  "Código del Proveedor 10": "",
  "Proveedor de redondeo 10": "",
  "Proveedor de lote mínimo 10": "",
  "Capacidad Máxima del camión 10": "",
  "Proveedor Incoterm 10": "",
  "Proveedor SLA 10": "",
  "Tiempo de tránsito del proveedor 10": "",
  "El proveedor crea una composición de carga automática 10": ""
}

export const UploadMasterdataEnCSVEmpty = {
  "Coordination": "",
  "Material Group": "",
  "Family": "",
  "Labeled Family": "",
  "Material Description": "",
  "Material Number": "",
  "Unit": "",
  "Unit measurement": "",
  "Description unit measurement": "",
  "Horizon schedule": "",
  "Minimum stock": "",
  "Maximum stock": "",
  "Supply point %": "",
  "Periodicity": "",
  "Auto accept load composition": "",
  "Sanitation of pending volumes": "",
  "Replanning delivery date": "",
  "Order grid replanning": "",
  "Active": "",
  "Production": "",
  "Responsible user email": "",
  "External Suggestion": "",
  "Future necessity": "",
  "Only Transfer Order": "",
  "Autopilot": "",
  "Deflator": "",
  "% Deflation": "",
  "Orders sanitation": "",
  "Days quantity to orders sanitation": "",
  "OOR Relevance": "",
  "Suggestions from D -": "",
  "Supplier name 1": "",
  "Supplier rounding 1": "",
  "Supplier minimum lot 1": "",
  "Supplier delivery break 1": "",
  "Supplier incoterm 1": "",
  "Supplier SLA 1": "",
  "Supplier transit time 1": "",
  "Supplier create automatic load composition 1": "",
  "Supplier name 2": "",
  "Supplier rounding 2": "",
  "Supplier minimum lot 2": "",
  "Supplier delivery break 2": "",
  "Supplier incoterm 2": "",
  "Supplier SLA 2": "",
  "Supplier transit time 2": "",
  "Supplier create automatic load composition 2": "",
  "Supplier name 3": "",
  "Supplier rounding 3": "",
  "Supplier minimum lot 3": "",
  "Supplier delivery break 3": "",
  "Supplier incoterm 3": "",
  "Supplier SLA 3": "",
  "Supplier transit time 3": "",
  "Supplier create automatic load composition 3": "",
  "Supplier name 4": "",
  "Supplier rounding 4": "",
  "Supplier minimum lot 4": "",
  "Supplier delivery break 4": "",
  "Supplier incoterm 4": "",
  "Supplier SLA 4": "",
  "Supplier transit time 4": "",
  "Supplier create automatic load composition 4": "",
  "Supplier name 5": "",
  "Supplier rounding 5": "",
  "Supplier minimum lot 5": "",
  "Supplier delivery break 5": "",
  "Supplier incoterm 5": "",
  "Supplier SLA 5": "",
  "Supplier transit time 5": "",
  "Supplier create automatic load composition 5": "",
  "Supplier name 6": "",
  "Supplier rounding 6": "",
  "Supplier minimum lot 6": "",
  "Supplier delivery break 6": "",
  "Supplier incoterm 6": "",
  "Supplier SLA 6": "",
  "Supplier transit time 6": "",
  "Supplier create automatic load composition 6": "",
  "Supplier name 7": "",
  "Supplier rounding 7": "",
  "Supplier minimum lot 7": "",
  "Supplier delivery break 7": "",
  "Supplier incoterm 7": "",
  "Supplier SLA 7": "",
  "Supplier transit time 7": "",
  "Supplier create automatic load composition 7": "",
  "Supplier name 8": "",
  "Supplier rounding 8": "",
  "Supplier minimum lot 8": "",
  "Supplier delivery break 8": "",
  "Supplier incoterm 8": "",
  "Supplier SLA 8": "",
  "Supplier transit time 8": "",
  "Supplier create automatic load composition 8": "",
  "Supplier name 9": "",
  "Supplier rounding 9": "",
  "Supplier minimum lot 9": "",
  "Supplier delivery break 9": "",
  "Supplier incoterm 9": "",
  "Supplier SLA 9": "",
  "Supplier transit time 9": "",
  "Supplier create automatic load composition 9": "",
  "Supplier name 10": "",
  "Supplier rounding 10": "",
  "Supplier minimum lot 10": "",
  "Supplier delivery break 10": "",
  "Supplier incoterm 10": "",
  "Supplier SLA 10": "",
  "Supplier transit time 10": "",
  "Supplier create automatic load composition 10": "",
}

export const UploadMasterdataPtBrCSVEmptyEnhanced = {
  "Coordenação": "",
  "Carteira": "",
  "Família": "",
  "Família Rotulada": "",
  "Centro": "",
  "Número Material": "",
  "Descrição Material": "",
  "Unidade medida": "",
  "Descrição unidade medida": "",
  "Horizonte programação": "",
  "Estoque mínimo": "",
  "Estoque máximo": "",
  "Ponto reabastecimento %": "",
  "Periodicidade": "",
  "Auto aceite composição carga": "",
  "Saneamento de volumes pendentes": "",
  "Replanejamento data entrega": "",
  "Replanejamento grade pedidos": "",
  "Necessidade futura": "",
  "Saneamento de pedidos": "",
  "Quantidade de dias para saneamento de pedidos": "",
  "Relevância OOR": "",
  "Reagendamento de Pedidos por Grade": "",
  "Política de Estoque Dinâmica": "",
  "Quebrar por carro": "",
  "Negociar composição de carga": "",
  "Liberar para mixar carga": "",
  "Acionamento de Transporte CIF": "",
  "Local de Armazenamento": "",
  "Hourly Plan": "",
  "Autopilot": "",
  "Sugestões a partir de D -": "",
  "Gestão de Estoques em Over": "",
  "Corte de Pedidos em Over A partir de D+": "",
  "Ativo": "",
  "Produção": "",
  "Apenas Transferencia": "",
  "Deflator": "",
  "% Deflação": "",
  "Email do usuário responsável": "",
  "Fornecedor código 1": "",
  "Fornecedor arredondamento 1": "",
  "Fornecedor lote mínimo 1": "",
  "Fornecedor quebra entrega 1": "",
  "Fornecedor incoterm 1": "",
  "Fornecedor SLA 1": "",
  "Fornecedor tempo transporte 1": "",
  "Fornecedor tempo de transporte porto-doca (dias) 1": "",
  "Fornecedor cria composição de carga automática 1": "",
  "Fornecedor aceita pedido automaticamente 1": "",
  "Fornecedor aceita volume automaticamente 1": "",
  "Fornecedor organização de compra 1": "",
  "Fornecedor grupo de compradores 1": "",
  "Fornecedor código de imposto 1": "",
  "Fornecedor código 2": "",
  "Fornecedor arredondamento 2": "",
  "Fornecedor lote mínimo 2": "",
  "Fornecedor quebra entrega 2": "",
  "Fornecedor incoterm 2": "",
  "Fornecedor SLA 2": "",
  "Fornecedor tempo transporte 2": "",
  "Fornecedor tempo de transporte porto-doca (dias) 2": "",
  "Fornecedor cria composição de carga automática 2": "",
  "Fornecedor aceita pedido automaticamente 2": "",
  "Fornecedor aceita volume automaticamente 2": "",
  "Fornecedor organização de compra 2": "",
  "Fornecedor grupo de compradores 2": "",
  "Fornecedor código de imposto 2": "",
  "Fornecedor código 3": "",
  "Fornecedor arredondamento 3": "",
  "Fornecedor lote mínimo 3": "",
  "Fornecedor quebra entrega 3": "",
  "Fornecedor incoterm 3": "",
  "Fornecedor SLA 3": "",
  "Fornecedor tempo transporte 3": "",
  "Fornecedor tempo de transporte porto-doca (dias) 3": "",
  "Fornecedor cria composição de carga automática 3": "",
  "Fornecedor aceita pedido automaticamente 3": "",
  "Fornecedor aceita volume automaticamente 3": "",
  "Fornecedor organização de compra 3": "",
  "Fornecedor grupo de compradores 3": "",
  "Fornecedor código de imposto 3": "",
  "Fornecedor código 4": "",
  "Fornecedor arredondamento 4": "",
  "Fornecedor lote mínimo 4": "",
  "Fornecedor quebra entrega 4": "",
  "Fornecedor incoterm 4": "",
  "Fornecedor SLA 4": "",
  "Fornecedor tempo transporte 4": "",
  "Fornecedor tempo de transporte porto-doca (dias) 4": "",
  "Fornecedor cria composição de carga automática 4": "",
  "Fornecedor aceita pedido automaticamente 4": "",
  "Fornecedor aceita volume automaticamente 4": "",
  "Fornecedor organização de compra 4": "",
  "Fornecedor grupo de compradores 4": "",
  "Fornecedor código de imposto 4": "",
  "Fornecedor código 5": "",
  "Fornecedor arredondamento 5": "",
  "Fornecedor lote mínimo 5": "",
  "Fornecedor quebra entrega 5": "",
  "Fornecedor incoterm 5": "",
  "Fornecedor SLA 5": "",
  "Fornecedor tempo transporte 5": "",
  "Fornecedor tempo de transporte porto-doca (dias) 5": "",
  "Fornecedor cria composição de carga automática 5": "",
  "Fornecedor aceita pedido automaticamente 5": "",
  "Fornecedor aceita volume automaticamente 5": "",
  "Fornecedor organização de compra 5": "",
  "Fornecedor grupo de compradores 5": "",
  "Fornecedor código de imposto 5": "",
  "Fornecedor código 6": "",
  "Fornecedor arredondamento 6": "",
  "Fornecedor lote mínimo 6": "",
  "Fornecedor quebra entrega 6": "",
  "Fornecedor incoterm 6": "",
  "Fornecedor SLA 6": "",
  "Fornecedor tempo transporte 6": "",
  "Fornecedor tempo de transporte porto-doca (dias) 6": "",
  "Fornecedor cria composição de carga automática 6": "",
  "Fornecedor aceita pedido automaticamente 6": "",
  "Fornecedor aceita volume automaticamente 6": "",
  "Fornecedor organização de compra 6": "",
  "Fornecedor grupo de compradores 6": "",
  "Fornecedor código de imposto 6": "",
  "Fornecedor código 7": "",
  "Fornecedor arredondamento 7": "",
  "Fornecedor lote mínimo 7": "",
  "Fornecedor quebra entrega 7": "",
  "Fornecedor incoterm 7": "",
  "Fornecedor SLA 7": "",
  "Fornecedor tempo transporte 7": "",
  "Fornecedor tempo de transporte porto-doca (dias) 7": "",
  "Fornecedor cria composição de carga automática 7": "",
  "Fornecedor aceita pedido automaticamente 7": "",
  "Fornecedor aceita volume automaticamente 7": "",
  "Fornecedor organização de compra 7": "",
  "Fornecedor grupo de compradores 7": "",
  "Fornecedor código de imposto 7": "",
  "Fornecedor código 8": "",
  "Fornecedor arredondamento 8": "",
  "Fornecedor lote mínimo 8": "",
  "Fornecedor quebra entrega 8": "",
  "Fornecedor incoterm 8": "",
  "Fornecedor SLA 8": "",
  "Fornecedor tempo transporte 8": "",
  "Fornecedor tempo de transporte porto-doca (dias) 8": "",
  "Fornecedor cria composição de carga automática 8": "",
  "Fornecedor aceita pedido automaticamente 8": "",
  "Fornecedor aceita volume automaticamente 8": "",
  "Fornecedor organização de compra 8": "",
  "Fornecedor grupo de compradores 8": "",
  "Fornecedor código de imposto 8": "",
  "Fornecedor código 9": "",
  "Fornecedor arredondamento 9": "",
  "Fornecedor lote mínimo 9": "",
  "Fornecedor quebra entrega 9": "",
  "Fornecedor incoterm 9": "",
  "Fornecedor SLA 9": "",
  "Fornecedor tempo transporte 9": "",
  "Fornecedor tempo de transporte porto-doca (dias) 9": "",
  "Fornecedor cria composição de carga automática 9": "",
  "Fornecedor aceita pedido automaticamente 9": "",
  "Fornecedor aceita volume automaticamente 9": "",
  "Fornecedor organização de compra 9": "",
  "Fornecedor grupo de compradores 9": "",
  "Fornecedor código de imposto 9": "",
  "Fornecedor código 10": "",
  "Fornecedor arredondamento 10": "",
  "Fornecedor lote mínimo 10": "",
  "Fornecedor quebra entrega 10": "",
  "Fornecedor incoterm 10": "",
  "Fornecedor SLA 10": "",
  "Fornecedor tempo transporte 10": "",
  "Fornecedor tempo de transporte porto-doca (dias) 10": "",
  "Fornecedor cria composição de carga automática 10": "",
  "Fornecedor aceita pedido automaticamente 10": "",
  "Fornecedor aceita volume automaticamente 10": "",
  "Fornecedor organização de compra 10": "",
  "Fornecedor grupo de compradores 10": "",
  "Fornecedor código de imposto 10": "",
}

export const UploadMasterdataEsCSVEmptyEnhanced = {
  "Coordinación": "",
  "Grupo de materiales": "",
  "Familia": "",
  "Familia Rotulada": "",
  "Centro": "",
  "Número Material": "",
  "Descripción Material": "",
  "Unidad medida": "",
  "Descripción de unidad de medida": "",
  "Horizonte de programación": "",
  "Stock mínimo": "",
  "Stock máximo": "",
  "Punto de reabastecimiento %": "",
  "Frecuencia": "",
  "Autoaceptar composición de carga": "",
  "Saneamiento de volúmenes pendientes": "",
  "Reprogramación de Fecha de Entrega": "",
  "Replanificación de Capacidad de Pedidos": "",
  "Necesidad Futura": "",
  "Órden de saneamiento": "",
  "Número de días para procesar pedidos": "",
  "Relevancia OOR": "",
  "Reprogramación de Pedidos por Grilla": "",
  "Política de Inventario Dinámico": "",
  "Dividir por camión": "",
  "Negociar composición de carga": "",
  "Liberar para mezclar carga": "",
  "Activación de Transporte CIF": "",
  "Lugar de Almacenamiento": "",
  "Plan por Hora": "",
  "Autopilot": "",
  "Sugerencias a partir de D -": "",
  "Gestión de Stocks en Over": "",
  "Corte de Pedidos en Over a partir de D+": "",
  "Activo": "",
  "Producción": "",
  "Solo pedido de translado": "",
  "Deflator": "",
  "% de Deflación": "",
  "Correo del usuario responsable": "",
  "Proveedor código 1": "",
  "Proveedor redondeo 1": "",
  "Proveedor lote mínimo 1": "",
  "Proveedor capacidad máxima del camión 1": "",
  "Proveedor incoterm 1": "",
  "Proveedor SLA 1": "",
  "Proveedor tiempo de translado 1": "",
  "Proveedor tiempo de tránsito puerto-muelle 1": "",
  "Proveedor crea una composición de carga automática 1": "",
  "Proveedor acepta pedido automáticamente 1": "",
  "Proveedor acepta volumen automáticamente 1": "",
  "Proveedor organización de compra 1": "",
  "Proveedor grupo de compradores 1": "",
  "Proveedor código de impuesto 1": "",
  "Proveedor código 2": "",
  "Proveedor redondeo 2": "",
  "Proveedor lote mínimo 2": "",
  "Proveedor capacidad máxima del camión 2": "",
  "Proveedor incoterm 2": "",
  "Proveedor SLA 2": "",
  "Proveedor tiempo de translado 2": "",
  "Proveedor tiempo de tránsito puerto-muelle 2": "",
  "Proveedor crea una composición de carga automática 2": "",
  "Proveedor acepta pedido automáticamente 2": "",
  "Proveedor acepta volumen automáticamente 2": "",
  "Proveedor organización de compra 2": "",
  "Proveedor grupo de compradores 2": "",
  "Proveedor código de impuesto 2": "",
  "Proveedor código 3": "",
  "Proveedor redondeo 3": "",
  "Proveedor lote mínimo 3": "",
  "Proveedor capacidad máxima del camión 3": "",
  "Proveedor incoterm 3": "",
  "Proveedor SLA 3": "",
  "Proveedor tiempo de translado 3": "",
  "Proveedor tiempo de tránsito puerto-muelle 3": "",
  "Proveedor crea una composición de carga automática 3": "",
  "Proveedor acepta pedido automáticamente 3": "",
  "Proveedor acepta volumen automáticamente 3": "",
  "Proveedor organización de compra 3": "",
  "Proveedor grupo de compradores 3": "",
  "Proveedor código de impuesto 3": "",
  "Proveedor código 4": "",
  "Proveedor redondeo 4": "",
  "Proveedor lote mínimo 4": "",
  "Proveedor capacidad máxima del camión 4": "",
  "Proveedor incoterm 4": "",
  "Proveedor SLA 4": "",
  "Proveedor tiempo de translado 4": "",
  "Proveedor tiempo de tránsito puerto-muelle 4": "",
  "Proveedor crea una composición de carga automática 4": "",
  "Proveedor acepta pedido automáticamente 4": "",
  "Proveedor acepta volumen automáticamente 4": "",
  "Proveedor organización de compra 4": "",
  "Proveedor grupo de compradores 4": "",
  "Proveedor código de impuesto 4": "",
  "Proveedor código 5": "",
  "Proveedor redondeo 5": "",
  "Proveedor lote mínimo 5": "",
  "Proveedor capacidad máxima del camión 5": "",
  "Proveedor incoterm 5": "",
  "Proveedor SLA 5": "",
  "Proveedor tiempo de translado 5": "",
  "Proveedor tiempo de tránsito puerto-muelle 5": "",
  "Proveedor crea una composición de carga automática 5": "",
  "Proveedor acepta pedido automáticamente 5": "",
  "Proveedor acepta volumen automáticamente 5": "",
  "Proveedor organización de compra 5": "",
  "Proveedor grupo de compradores 5": "",
  "Proveedor código de impuesto 5": "",
  "Proveedor código 6": "",
  "Proveedor redondeo 6": "",
  "Proveedor lote mínimo 6": "",
  "Proveedor capacidad máxima del camión 6": "",
  "Proveedor incoterm 6": "",
  "Proveedor SLA 6": "",
  "Proveedor tiempo de translado 6": "",
  "Proveedor tiempo de tránsito puerto-muelle 6": "",
  "Proveedor crea una composición de carga automática 6": "",
  "Proveedor acepta pedido automáticamente 6": "",
  "Proveedor acepta volumen automáticamente 6": "",
  "Proveedor organización de compra 6": "",
  "Proveedor grupo de compradores 6": "",
  "Proveedor código de impuesto 6": "",
  "Proveedor código 7": "",
  "Proveedor redondeo 7": "",
  "Proveedor lote mínimo 7": "",
  "Proveedor capacidad máxima del camión 7": "",
  "Proveedor incoterm 7": "",
  "Proveedor SLA 7": "",
  "Proveedor tiempo de translado 7": "",
  "Proveedor tiempo de tránsito puerto-muelle 7": "",
  "Proveedor crea una composición de carga automática 7": "",
  "Proveedor acepta pedido automáticamente 7": "",
  "Proveedor acepta volumen automáticamente 7": "",
  "Proveedor organización de compra 7": "",
  "Proveedor grupo de compradores 7": "",
  "Proveedor código de impuesto 7": "",
  "Proveedor código 8": "",
  "Proveedor redondeo 8": "",
  "Proveedor lote mínimo 8": "",
  "Proveedor capacidad máxima del camión 8": "",
  "Proveedor incoterm 8": "",
  "Proveedor SLA 8": "",
  "Proveedor tiempo de translado 8": "",
  "Proveedor tiempo de tránsito puerto-muelle 8": "",
  "Proveedor crea una composición de carga automática 8": "",
  "Proveedor acepta pedido automáticamente 8": "",
  "Proveedor acepta volumen automáticamente 8": "",
  "Proveedor organización de compra 8": "",
  "Proveedor grupo de compradores 8": "",
  "Proveedor código de impuesto 8": "",
  "Proveedor código 9": "",
  "Proveedor redondeo 9": "",
  "Proveedor lote mínimo 9": "",
  "Proveedor capacidad máxima del camión 9": "",
  "Proveedor incoterm 9": "",
  "Proveedor SLA 9": "",
  "Proveedor tiempo de translado 9": "",
  "Proveedor tiempo de tránsito puerto-muelle 9": "",
  "Proveedor crea una composición de carga automática 9": "",
  "Proveedor acepta pedido automáticamente 9": "",
  "Proveedor acepta volumen automáticamente 9": "",
  "Proveedor organización de compra 9": "",
  "Proveedor grupo de compradores 9": "",
  "Proveedor código de impuesto 9": "",
  "Proveedor código 10": "",
  "Proveedor redondeo 10": "",
  "Proveedor lote mínimo 10": "",
  "Proveedor capacidad máxima del camión 10": "",
  "Proveedor incoterm 10": "",
  "Proveedor SLA 10": "",
  "Proveedor tiempo de translado 10": "",
  "Proveedor tiempo de tránsito puerto-muelle 10": "",
  "Proveedor crea una composición de carga automática 10": "",
  "Proveedor acepta pedido automáticamente 10": "",
  "Proveedor acepta volumen automáticamente 10": "",
  "Proveedor organización de compra 10": "",
  "Proveedor grupo de compradores 10": "",
  "Proveedor código de impuesto 10": "",
}

export const UploadMasterdataEnCSVEmptyEnhanced = {
  "Coordination": "",
  "Material Group": "",
  "Family": "",
  "Labeled Family": "",
  "Unit": "",
  "Material Number": "",
  "Material Description": "",
  "Unit measurement": "",
  "Description unit measurement": "",
  "Horizon schedule": "",
  "Minimum stock": "",
  "Maximum stock": "",
  "Supply point %": "",
  "Periodicity": "",
  "Auto accept load composition": "",
  "Sanitation of pending volumes": "",
  "Replanning delivery date": "",
  "Order grid replanning": "",
  "Future necessity": "",
  "Orders sanitation": "",
  "Days quantity to orders sanitation": "",
  "OOR Relevance": "",
  "Order Rescheduling by Grid": "",
  "Dynamic Inventory Policy": "",
  "Break by car": "",
  "Negotiate load composition": "",
  "Release to mix load": "",
  "CIF Transport Activation": "",
  "Storage Location": "",
  "Hourly Plan": "",
  "Autopilot": "",
  "Suggestions from D -": "",
  "Over Stock Management": "",
  "Order Cut-off Over from D+": "",
  "Active": "",
  "Production": "",
  "Only Transfer Order": "",
  "Deflator": "",
  "% Deflation": "",
  "Responsible user email": "",
  "Supplier code 1": "",
  "Supplier rounding 1": "",
  "Supplier minimum lot 1": "",
  "Supplier delivery break 1": "",
  "Supplier incoterm 1": "",
  "Supplier SLA 1": "",
  "Supplier transit time 1": "",
  "Supplier port to dock transit time (days) 1": "",
  "Supplier create automatic load composition 1": "",
  "Supplier accepts order automatically 1": "",
  "Supplier accepts volume automatically 1": "",
  "Supplier purchasing organization 1": "",
  "Supplier buyer group 1": "",
  "Supplier tax code 1": "",
  "Supplier code 2": "",
  "Supplier rounding 2": "",
  "Supplier minimum lot 2": "",
  "Supplier delivery break 2": "",
  "Supplier incoterm 2": "",
  "Supplier SLA 2": "",
  "Supplier transit time 2": "",
  "Supplier port to dock transit time (days) 2": "",
  "Supplier create automatic load composition 2": "",
  "Supplier accepts order automatically 2": "",
  "Supplier accepts volume automatically 2": "",
  "Supplier purchasing organization 2": "",
  "Supplier buyer group 2": "",
  "Supplier tax code 2": "",
  "Supplier code 3": "",
  "Supplier rounding 3": "",
  "Supplier minimum lot 3": "",
  "Supplier delivery break 3": "",
  "Supplier incoterm 3": "",
  "Supplier SLA 3": "",
  "Supplier transit time 3": "",
  "Supplier port to dock transit time (days) 3": "",
  "Supplier create automatic load composition 3": "",
  "Supplier accepts order automatically 3": "",
  "Supplier accepts volume automatically 3": "",
  "Supplier purchasing organization 3": "",
  "Supplier buyer group 3": "",
  "Supplier tax code 3": "",
  "Supplier code 4": "",
  "Supplier rounding 4": "",
  "Supplier minimum lot 4": "",
  "Supplier delivery break 4": "",
  "Supplier incoterm 4": "",
  "Supplier SLA 4": "",
  "Supplier transit time 4": "",
  "Supplier port to dock transit time (days) 4": "",
  "Supplier create automatic load composition 4": "",
  "Supplier accepts order automatically 4": "",
  "Supplier accepts volume automatically 4": "",
  "Supplier purchasing organization 4": "",
  "Supplier buyer group 4": "",
  "Supplier tax code 4": "",
  "Supplier code 5": "",
  "Supplier rounding 5": "",
  "Supplier minimum lot 5": "",
  "Supplier delivery break 5": "",
  "Supplier incoterm 5": "",
  "Supplier SLA 5": "",
  "Supplier transit time 5": "",
  "Supplier port to dock transit time (days) 5": "",
  "Supplier create automatic load composition 5": "",
  "Supplier accepts order automatically 5": "",
  "Supplier accepts volume automatically 5": "",
  "Supplier purchasing organization 5": "",
  "Supplier buyer group 5": "",
  "Supplier tax code 5": "",
  "Supplier code 6": "",
  "Supplier rounding 6": "",
  "Supplier minimum lot 6": "",
  "Supplier delivery break 6": "",
  "Supplier incoterm 6": "",
  "Supplier SLA 6": "",
  "Supplier transit time 6": "",
  "Supplier port to dock transit time (days) 6": "",
  "Supplier create automatic load composition 6": "",
  "Supplier accepts order automatically 6": "",
  "Supplier accepts volume automatically 6": "",
  "Supplier purchasing organization 6": "",
  "Supplier buyer group 6": "",
  "Supplier tax code 6": "",
  "Supplier code 7": "",
  "Supplier rounding 7": "",
  "Supplier minimum lot 7": "",
  "Supplier delivery break 7": "",
  "Supplier incoterm 7": "",
  "Supplier SLA 7": "",
  "Supplier transit time 7": "",
  "Supplier port to dock transit time (days) 7": "",
  "Supplier create automatic load composition 7": "",
  "Supplier accepts order automatically 7": "",
  "Supplier accepts volume automatically 7": "",
  "Supplier purchasing organization 7": "",
  "Supplier buyer group 7": "",
  "Supplier tax code 7": "",
  "Supplier code 8": "",
  "Supplier rounding 8": "",
  "Supplier minimum lot 8": "",
  "Supplier delivery break 8": "",
  "Supplier incoterm 8": "",
  "Supplier SLA 8": "",
  "Supplier transit time 8": "",
  "Supplier port to dock transit time (days) 8": "",
  "Supplier create automatic load composition 8": "",
  "Supplier accepts order automatically 8": "",
  "Supplier accepts volume automatically 8": "",
  "Supplier purchasing organization 8": "",
  "Supplier buyer group 8": "",
  "Supplier tax code 8": "",
  "Supplier code 9": "",
  "Supplier rounding 9": "",
  "Supplier minimum lot 9": "",
  "Supplier delivery break 9": "",
  "Supplier incoterm 9": "",
  "Supplier SLA 9": "",
  "Supplier transit time 9": "",
  "Supplier port to dock transit time (days) 9": "",
  "Supplier create automatic load composition 9": "",
  "Supplier accepts order automatically 9": "",
  "Supplier accepts volume automatically 9": "",
  "Supplier purchasing organization 9": "",
  "Supplier buyer group 9": "",
  "Supplier tax code 9": "",
  "Supplier code 10": "",
  "Supplier rounding 10": "",
  "Supplier minimum lot 10": "",
  "Supplier delivery break 10": "",
  "Supplier incoterm 10": "",
  "Supplier SLA 10": "",
  "Supplier transit time 10": "",
  "Supplier port to dock transit time (days) 10": "",
  "Supplier create automatic load composition 10": "",
  "Supplier accepts order automatically 10": "",
  "Supplier accepts volume automatically 10": "",
  "Supplier purchasing organization 10": "",
  "Supplier buyer group 10": "",
  "Supplier tax code 10": "",
}

export const UploadMasterdataRequiredFieldsPtBr = [
  'Coordenação',
  'Carteira',
  'Família',
  'Família Rotulada',
  'Número Material',
  'Centro'
];

export const UploadMasterdataRequiredFieldsEs = [
  'Coordinación',
  'Grupo de materiales',
  'Familia',
  'Familia Rotulada',
  'Número Material',
  'Centro'
];

export const UploadMasterdataRequiredFieldsEn = [
  'Coordination',
  'Material Group',
  'Family',
  'Labeled Family',
  'Material Number',
  'Unit',
];

export interface IUploadMasterdata {
  line: number;
  coordenacao: string;
  carteira: string;
  familia: string;
  familiaRotulada: string;
  descricaoMaterial: string;
  numeroMaterial: string;
  centro: string;
  unidadeMedida: string;
  descricaoUnidadeMedida: string;
  horizonteProgramacao?: number;
  minEstoque?: number;
  maxEstoque?: number;
  porcentagemPontoReabastecimento?: number;
  periodicity: string;
  autoAceiteComposicaoCarga: boolean;
  saneamentoDeVolumesPendentes: boolean;
  replanejamentoDataEntrega: boolean;
  replanejamentoGradePedidos?: number;
  active: boolean;
  production: boolean;
  responsibleUserEmail: string;
  externalSuggestion: boolean;
  futureNecessity: boolean;
  onlyTransferOrder: boolean;
  autoPilot: boolean;
  deflator: boolean;
  deflationPercentage?: number;
  saneamentoDePedidos: boolean;
  quantidadeDiasParaSaneamentoPedidos?: number;
  relevanciaOor: boolean;
  quantidadeDeDiasAntecipadoParaGeracaoSugestao?: number;
  fornecedor_1_Nome: string;
  fornecedor_1_Arredondamento?: number;
  fornecedor_1_LoteMinimo?: number;
  fornecedor_1_QuebraDeEntrega?: number;
  fornecedor_1_Incoterm: string;
  fornecedor_1_Sla?: number;
  fornecedor_1_TransitTime?: number;
  fornecedor_1_Create_Load_Composition: boolean;
  fornecedor_2_Nome: string;
  fornecedor_2_Arredondamento?: number;
  fornecedor_2_LoteMinimo?: number;
  fornecedor_2_QuebraDeEntrega?: number;
  fornecedor_2_Incoterm: string;
  fornecedor_2_Sla?: number;
  fornecedor_2_TransitTime?: number;
  fornecedor_2_Create_Load_Composition: boolean;
  fornecedor_3_Nome: string;
  fornecedor_3_Arredondamento?: number;
  fornecedor_3_LoteMinimo?: number;
  fornecedor_3_QuebraDeEntrega?: number;
  fornecedor_3_Incoterm: string;
  fornecedor_3_Sla?: number;
  fornecedor_3_TransitTime?: number;
  fornecedor_3_Create_Load_Composition: boolean;
  fornecedor_4_Nome: string;
  fornecedor_4_Arredondamento?: number;
  fornecedor_4_LoteMinimo?: number;
  fornecedor_4_QuebraDeEntrega?: number;
  fornecedor_4_Incoterm: string;
  fornecedor_4_Sla?: number;
  fornecedor_4_TransitTime?: number;
  fornecedor_4_Create_Load_Composition: boolean;
  fornecedor_5_Nome: string;
  fornecedor_5_Arredondamento?: number;
  fornecedor_5_LoteMinimo?: number;
  fornecedor_5_QuebraDeEntrega?: number;
  fornecedor_5_Incoterm: string;
  fornecedor_5_Sla?: number;
  fornecedor_5_TransitTime?: number;
  fornecedor_5_Create_Load_Composition: boolean;
  fornecedor_6_Nome: string;
  fornecedor_6_Arredondamento?: number;
  fornecedor_6_LoteMinimo?: number;
  fornecedor_6_QuebraDeEntrega?: number;
  fornecedor_6_Incoterm: string;
  fornecedor_6_Sla?: number;
  fornecedor_6_TransitTime?: number;
  fornecedor_6_Create_Load_Composition: boolean;
  fornecedor_7_Nome: string;
  fornecedor_7_Arredondamento?: number;
  fornecedor_7_LoteMinimo?: number;
  fornecedor_7_QuebraDeEntrega?: number;
  fornecedor_7_Incoterm: string;
  fornecedor_7_Sla?: number;
  fornecedor_7_TransitTime?: number;
  fornecedor_7_Create_Load_Composition: boolean;
  fornecedor_8_Nome: string;
  fornecedor_8_Arredondamento?: number;
  fornecedor_8_LoteMinimo?: number;
  fornecedor_8_QuebraDeEntrega?: number;
  fornecedor_8_Incoterm: string;
  fornecedor_8_Sla?: number;
  fornecedor_8_TransitTime?: number;
  fornecedor_8_Create_Load_Composition: boolean;
  fornecedor_9_Nome: string;
  fornecedor_9_Arredondamento?: number;
  fornecedor_9_LoteMinimo?: number;
  fornecedor_9_QuebraDeEntrega?: number;
  fornecedor_9_Incoterm: string;
  fornecedor_9_Sla?: number;
  fornecedor_9_TransitTime?: number;
  fornecedor_9_Create_Load_Composition: boolean;
  fornecedor_10_Nome: string;
  fornecedor_10_Arredondamento?: number;
  fornecedor_10_LoteMinimo?: number;
  fornecedor_10_QuebraDeEntrega?: number;
  fornecedor_10_Incoterm: string;
  fornecedor_10_Sla?: number;
  fornecedor_10_TransitTime?: number;
  fornecedor_10_Create_Load_Composition: boolean;
  updateUploadInfo?: boolean;
  // Enhanced fields (FeatureMasterDataEnhancements)
  reagendamentoDePedidosPorGrade?: boolean;
  politicaDeEstoqueDinamica?: boolean;
  quebrarPorCarro?: boolean;
  negociarComposicaoDeCarga?: boolean;
  liberarParaMixarCarga?: boolean;
  acionamentoDeTransporteCIF?: boolean;
  localDeArmazenamento?: boolean;
  hourlyPlan?: boolean;
  gestaoDeEstoquesEmOver?: boolean;
  corteDePedidosEmOverAPartirDeD?: number;
  fornecedor_1_TempoTransportePortoDoca?: number;
  fornecedor_1_AceitaPedidoAutomaticamente?: boolean;
  fornecedor_1_AceitaVolumeAutomaticamente?: boolean;
  fornecedor_1_OrganizacaoDeCompra?: string;
  fornecedor_1_GrupoDeCompradores?: string;
  fornecedor_1_CodigoDeImposto?: string;
  fornecedor_2_TempoTransportePortoDoca?: number;
  fornecedor_2_AceitaPedidoAutomaticamente?: boolean;
  fornecedor_2_AceitaVolumeAutomaticamente?: boolean;
  fornecedor_2_OrganizacaoDeCompra?: string;
  fornecedor_2_GrupoDeCompradores?: string;
  fornecedor_2_CodigoDeImposto?: string;
  fornecedor_3_TempoTransportePortoDoca?: number;
  fornecedor_3_AceitaPedidoAutomaticamente?: boolean;
  fornecedor_3_AceitaVolumeAutomaticamente?: boolean;
  fornecedor_3_OrganizacaoDeCompra?: string;
  fornecedor_3_GrupoDeCompradores?: string;
  fornecedor_3_CodigoDeImposto?: string;
  fornecedor_4_TempoTransportePortoDoca?: number;
  fornecedor_4_AceitaPedidoAutomaticamente?: boolean;
  fornecedor_4_AceitaVolumeAutomaticamente?: boolean;
  fornecedor_4_OrganizacaoDeCompra?: string;
  fornecedor_4_GrupoDeCompradores?: string;
  fornecedor_4_CodigoDeImposto?: string;
  fornecedor_5_TempoTransportePortoDoca?: number;
  fornecedor_5_AceitaPedidoAutomaticamente?: boolean;
  fornecedor_5_AceitaVolumeAutomaticamente?: boolean;
  fornecedor_5_OrganizacaoDeCompra?: string;
  fornecedor_5_GrupoDeCompradores?: string;
  fornecedor_5_CodigoDeImposto?: string;
  fornecedor_6_TempoTransportePortoDoca?: number;
  fornecedor_6_AceitaPedidoAutomaticamente?: boolean;
  fornecedor_6_AceitaVolumeAutomaticamente?: boolean;
  fornecedor_6_OrganizacaoDeCompra?: string;
  fornecedor_6_GrupoDeCompradores?: string;
  fornecedor_6_CodigoDeImposto?: string;
  fornecedor_7_TempoTransportePortoDoca?: number;
  fornecedor_7_AceitaPedidoAutomaticamente?: boolean;
  fornecedor_7_AceitaVolumeAutomaticamente?: boolean;
  fornecedor_7_OrganizacaoDeCompra?: string;
  fornecedor_7_GrupoDeCompradores?: string;
  fornecedor_7_CodigoDeImposto?: string;
  fornecedor_8_TempoTransportePortoDoca?: number;
  fornecedor_8_AceitaPedidoAutomaticamente?: boolean;
  fornecedor_8_AceitaVolumeAutomaticamente?: boolean;
  fornecedor_8_OrganizacaoDeCompra?: string;
  fornecedor_8_GrupoDeCompradores?: string;
  fornecedor_8_CodigoDeImposto?: string;
  fornecedor_9_TempoTransportePortoDoca?: number;
  fornecedor_9_AceitaPedidoAutomaticamente?: boolean;
  fornecedor_9_AceitaVolumeAutomaticamente?: boolean;
  fornecedor_9_OrganizacaoDeCompra?: string;
  fornecedor_9_GrupoDeCompradores?: string;
  fornecedor_9_CodigoDeImposto?: string;
  fornecedor_10_TempoTransportePortoDoca?: number;
  fornecedor_10_AceitaPedidoAutomaticamente?: boolean;
  fornecedor_10_AceitaVolumeAutomaticamente?: boolean;
  fornecedor_10_OrganizacaoDeCompra?: string;
  fornecedor_10_GrupoDeCompradores?: string;
  fornecedor_10_CodigoDeImposto?: string;
}